import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { API } from "@/config";

const SiteContentCtx = React.createContext({ get: (_k, fallback) => fallback, reload: () => {} });
export const useSiteContent = () => React.useContext(SiteContentCtx);

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/site-content`);
      setContent(r.data.content || {});
    } catch { /* ignore — fallbacks in <T> will cover */ }
  }, []);
  useEffect(() => { load(); }, [load]);
  const value = useMemo(() => ({
    get: (k, fallback = "") => (content[k] != null && content[k] !== "" ? content[k] : fallback),
    reload: load,
  }), [content, load]);
  return <SiteContentCtx.Provider value={value}>{children}</SiteContentCtx.Provider>;
};

/* Tiny helper — <T k="hero.eyebrow" fallback="Free delivery, everywhere." /> */
export const T = ({ k, fallback = "" }) => {
  const { get } = useSiteContent();
  return <>{get(k, fallback)}</>;
};
